import Loadable from 'react-loadable'
import Loading from '../../components/Loading'

export const AdminManagement = Loadable({
  loader: () => import('./Admin'),
  loading: Loading
})

export const RegisterManagement = Loadable({
  loader: () => import('./Register'),
  loading: Loading
})

export const Welcome = Loadable({
  loader: () => import('./Register/welcome'),
  loading: Loading
})

export default {
  AdminManagement,
  RegisterManagement,
  Welcome
}


// WEBPACK FOOTER //
// ./src/containers/Management/index.js